import React from 'react';
import _ from 'lodash';
import {prepareDataForScreen, prepareProductCategories, SCREENS} from 'dashboard/processing/PostingSharedMethods';
import config from '../../../config';

export function qualityCheckAnswerHandler(params) {
  console.log('params', params  );
  const {foundItemIndex, dataToUpdate = {}, keepThisQualityCheck = false,
    detailTextToUpdate = 'n/a'} = params;
  let {penaltyToApply = 'n/a', postingModalTitle = false, postingModalConfirmHandler = false} = params;
  const self = this;
  const {screensData = {}} = this.state;
  let updatedQualityCheck =  {...screensData.qualityCheckItems[foundItemIndex], ...dataToUpdate};
  const {selectedAnswer = {}} = dataToUpdate;
  let screenDataToSet = {
    qualityCheckItems: [...screensData.qualityCheckItems.slice(0, foundItemIndex),
      updatedQualityCheck,
      ...screensData.qualityCheckItems.slice(foundItemIndex + 1)],
    currentQualityCheckRecord: updatedQualityCheck
  };
  let sellerType = getSellerType.call(self);

  if(detailTextToUpdate !== 'n/a') {
    screenDataToSet.Details = detailTextToUpdate;
  }

  if(updatedQualityCheck.qualityCheckType == config.deterministicQualityCheckTypes.Base && !keepThisQualityCheck) {
    const {AnswerCustomData = {}} = selectedAnswer;

    if(AnswerCustomData.ModalTitle) {
      postingModalTitle = AnswerCustomData.ModalTitle;
    }
    const {selectedAnswer:previousSelectedAnswer = {}, firstBaseQualityCheck = false} = screensData.qualityCheckItems[foundItemIndex];
    if(firstBaseQualityCheck && previousSelectedAnswer.AnswerText && selectedAnswer.AnswerText && selectedAnswer.AnswerText !== previousSelectedAnswer.AnswerText) {
      /* if user returned back to the first Base quality check and changed original answer, we reset all Base quality checks as previous answers for Base quality checks are not relevant longer */

      const lastBaseItemIndex = screensData.qualityCheckItems.findLastIndex(item=>item.qualityCheckType == config.deterministicQualityCheckTypes.Base);
      const penaltyToRestore = screensData.qualityCheckItems.reduce((total, item, index) =>{
        if(index == foundItemIndex) { /* skip Penalty for the current answer as it is already included in params.penaltyToApply */
          return total;
        }

        if(item.qualityCheckType == config.deterministicQualityCheckTypes.Base && item.selectedAnswer && item.selectedAnswer.Penalty) {
          return total + item.selectedAnswer.Penalty;
        }

        return total;
      },0);
      if(penaltyToRestore !== 0 ) {
        penaltyToApply = penaltyToApply == 'n/a' ?  -penaltyToRestore : penaltyToApply - penaltyToRestore;
      }
      let baseQualityChecks = _.cloneDeep(screensData.baseQualityCheckItems);
      baseQualityChecks.shift();
      /* replace Base QC with original Base QC items, except the current first Base QC */
      screenDataToSet.qualityCheckItems.splice(foundItemIndex + 1, lastBaseItemIndex - foundItemIndex );
      screenDataToSet.qualityCheckItems.splice(foundItemIndex + 1, 0, ...baseQualityChecks);
    }


    let nextQC = selectedAnswer.NextQC;

    if(sellerType == 'partner' && AnswerCustomData['PartnerNextQC'] ) {
      nextQC = AnswerCustomData['PartnerNextQC'];
    }


    if (nextQC) {
      const nextQualityCheckIndex = screenDataToSet.qualityCheckItems.findIndex(qualityCheck =>qualityCheck.ItemNumber && nextQC == qualityCheck.ItemNumber.toString());
      if(nextQualityCheckIndex !== -1) {
        [screenDataToSet.qualityCheckItems[foundItemIndex + 1], screenDataToSet.qualityCheckItems[nextQualityCheckIndex]] = [screenDataToSet.qualityCheckItems[nextQualityCheckIndex], screenDataToSet.qualityCheckItems[foundItemIndex + 1]];
      }
    } else if(selectedAnswer.AnswerText) { /* this is the last Base Quality Check, remove all unused Base Quality Checks */
      screenDataToSet.qualityCheckItems = screenDataToSet.qualityCheckItems.filter(item=>{
        return !(item.qualityCheckType == config.deterministicQualityCheckTypes.Base && !item.selectedAnswer);
      });
    }
  }

  if(postingModalTitle && !dataToUpdate.modalDisplayed) {
    self.setScreensData({
      postingModalTitle,
      postingModalConfirmHandler: ()=>{
        if(postingModalConfirmHandler) {
         return postingModalConfirmHandler();
        }

        qualityCheckAnswerHandler.call(self,  {...params,
          dataToUpdate: {
            ...params.dataToUpdate,
            modalDisplayed: true
          }
        });
      }
    });
    return self.setState({ showPostingModalDialog:true });
  }
  let ratingToCheck = screensData.currentConditionRating;
  if(penaltyToApply !== 'n/a') {
    ratingToCheck = screenDataToSet.currentConditionRating = screensData.currentConditionRating - penaltyToApply;
      const currentCondition = config.conditionsData.filter(item=>item.scaleData).find(condition => {
      return condition.scaleData[sellerType] && screenDataToSet.currentConditionRating >= condition.scaleData[sellerType][0] && screenDataToSet.currentConditionRating <= condition.scaleData[sellerType][1];
    });

    if(currentCondition) {
      screenDataToSet.Condition = currentCondition.number;
    }
  }
  self.setScreensData(screenDataToSet, () => {
    if(keepThisQualityCheck) {
      return;
    }

    setTimeout(() => {
      if (((penaltyToApply == 'n/a' && ratingToCheck <= 0) || ratingToCheck > 0) && screenDataToSet.qualityCheckItems[foundItemIndex + 1]) {
        /* do not go to Failed Quality Check screen if ratingToCheck is <= 0 and it was not changed to this value with the current Quality Check.
         It can happen when user returned back to Quality Checks from Failed Quality Check screen */
        self.setScreensData({
          currentQualityCheckRecord: screenDataToSet.qualityCheckItems[foundItemIndex + 1]
        });
      } else {
       let nextScreenData = {screenDataToSet: {currentQualityCheckRecord: _.first(self.state.screensData.qualityCheckItems)}};
        let dataToSave = prepareDataForScreen.call(self);
        let nextScreen = SCREENS.fees_screen.key;

        if(self.state.currentFlow == '3PLProcessingFlow') {

          if(self.state.screensData.selectedGBGProduct) {
            nextScreen = SCREENS.listing_selection_screen.key;

            nextScreenData.nextScreenCallback = () => {
              self.searchProducts();
            };
          } else{
            nextScreen = SCREENS.fees_screen.key;
          }
        }
        if(ratingToCheck <= 0) {
          nextScreen = SCREENS.item_failed_quality_check_screen.key;
        }

        if (self.state.screensData.inboundProductId) {
          nextScreen = SCREENS.inbound_rebound_add_inventory.key
        }

        self.setScreensData(dataToSave,
          function () {
            self.goToNextScreen(nextScreen, nextScreenData );
          });
      }
    }, 1);
  });
}

export function getSellerType() {
  let sellerType = 'seller';
  const {CurrentProductData = {}, inboundProductId } = this.state.screensData;

  if (inboundProductId && CurrentProductData?.SellerID?.InventoryOwnership == 'SellerConsigned') {
    return 'seller'
  }
  if(this.state.currentFlow == '3PLProcessingFlow' || CurrentProductData.SellerID.InventoryOwnership == 'PartnerConsigned' ||  CurrentProductData.PalletID) {
    sellerType = 'partner';
  }

  return sellerType;
}
export function selectProductListing({GBGProductsFieldsToKeep, selectedProduct}) {
  console.log('selectProductListing', selectedProduct  );
  const self = this;
    self.updateScreensData({
      upToCurrentScreen: true,
      additionalFieldsToKeep: GBGProductsFieldsToKeep,
      callbackMethod: function () {
        self.setScreensData({
            QuantityToAdd: 1,
            ProductCategories: prepareProductCategories.call(this, {
              selectedGBGProduct: self.state.screensData.selectedGBGProduct,
              AllCategories: self.state.AllCategories,
            }),
            CurrentPartnerProductData: selectedProduct,
            GBGProductsData: [],
            imageToDisplay:false},
          function () {
            self.goToNextScreen(SCREENS.fees_screen.key);
          });
      }
    });

}